import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Typography,
  useTheme
} from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

const LanguageSelector = ({ variant = 'outlined', size = 'small' }) => {
  const { changeLanguage, currentLanguage, supportedLanguages } = useTranslation();
  const theme = useTheme();

  const languageLabels = {
    fr: 'Français',
    en: 'English',
    es: 'Español',
    it: 'Italiano'
  };

  const languageFlags = {
    fr: '🇫🇷',
    en: '🇬🇧',
    es: '🇪🇸',
    it: '🇮🇹'
  };

  const handleLanguageChange = (event) => {
    changeLanguage(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* <LanguageIcon sx={{ color: theme.palette.text.secondary, fontSize: 20 }} /> */}
      <FormControl variant={variant} size={size} sx={{ minWidth: 60 }}>
        <Select
          value={currentLanguage}
          onChange={handleLanguageChange}
          sx={{
            '& .MuiSelect-select': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1
            }
          }}
        >
          {supportedLanguages.map((lang) => (
            <MenuItem key={lang} value={lang}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography component="span" sx={{ fontSize: '1.2em' }}>
                  {languageFlags[lang]}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector;